const IncrementProtocol = ({ handleDownload, isLoading }) => {
  return (
    <button
      type="button"
      onClick={handleDownload}
      className={`${
        isLoading ? "cursor-wait bg-secondary" : "cursor-pointer bg-dark"
      } uppercase flex flex-row gap-2 items-center p-2 text-white rounded bg-dark hover:bg-secondary justify-center max-h-[38px]`}
    >
      Voir le protocole d'incrementation
    </button>
  );
};

export default IncrementProtocol;
